<template>
  <div class="AreaMsgzqAreaPage">
    <!-- <van-cell-group class="forestInput" v-if="!showNonezqAreaPage"> -->
    <van-cell-group class="forestInput">
      <van-field
        :value="baseData.gridName ? baseData.gridName : '无'"
        readonly
        label="政区名称："
      />
      <van-field
        :value="getGridLevel(baseData.gridLevel)"
        readonly
        label="政区级别："
      />
      <van-field
        :value="baseData.area ? baseData.area : '无'"
        readonly
        label="面积(公顷)："
      />
      <van-field
        rows="1"
        autosize
        type="textarea"
        v-for="(item, index) in baseData.regionUserList"
        :key="index"
        :value="item.userName ? item.userName : '无'"
        readonly
        :label="item.post + '：'"
      />
    </van-cell-group>

    <p class="subordinateTit" v-if="!showNonezqAreaPage">下级责任区</p>
    <div class="downAreaList" v-if="!showNonezqAreaPage">
      <van-list
        v-model="loading"
        :finished="zqAreaFinished"
        @load="onLoad"
        :offset="100"
        finished-text="没有更多了"
        class="subordinateArea"
      >
        <van-cell v-for="item in resultData" :key="item.id" class="childArea">
          <div class="childBox clearfix">
            <span class="tit">{{ item.gridName }}</span>
            <ul>
              <li
                v-for="(itemchild, childIndex) in item.gridPostList"
                :key="childIndex"
              >
                {{ itemchild.post }}：
                <span>{{
                  itemchild.userNames ? itemchild.userNames : "无"
                }}</span>
              </li>
            </ul>
          </div>
        </van-cell>
      </van-list>
      <div
        class="nonezqAreaPage"
        v-if="this.resultData.length < 1 && zqAreaFinished"
      >
        <img :src="nonePng" alt />
        <p>暂无数据</p>
      </div>
    </div>
  </div>
</template>
<script>
/*eslint-disable*/
// import { getToken } from "@/utils/common";
import nonePng from "@/assets/none.png";
import { getDeviceType } from "@/common/getDeviceType/getDeviceType";
export default {
  name: "zqAreaMsg",
  data() {
    return {
      showNonezqAreaPage: true,
      nonePng: nonePng, //默认图片

      gridLevel: "", //等级
      baseData: {},
      resultData: [],
      backstagelists: [],
      zqAreaPage: 0,
      zqAreaPageSize: 10,
      commentCount: 0,
      loading: false, //是否处于加载状态
      zqAreaFinished: false, //是否已加载完所有数据
      isLoading: false, //是否处于下拉刷新状态
      clientType: "", //手机类型
    };
  },
  props: {
    dataInfo: {
      type: Object,
      default: () => {
        {
          return {};
        }
      },
    },
  },
  mounted() {
    this.clientType = getDeviceType();
    this.$nextTick(function () {
      if (this.dataInfo.objid && this.dataInfo.level) {
        this.initzqAreaPage();
      }
    });
  },
  methods: {
    initzqAreaPage() {
      let _this = this;
      _this.$api.universal.dutyArea
        .zqDutyMsg({
          objid: _this.dataInfo.objid,
          regionLevel: _this.dataInfo.level,
        })
        .then((res) => {
          if (res.code == "1" && res.data != null) {
            _this.showNonezqAreaPage = false;
            _this.baseData = Object.assign({}, _this.baseData, res.data);
            _this.downList();
          } else {
            console.log(res.msg);
            _this.$toast(res.msg);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },

    downList() {
      let _this = this;
      if (
        _this.zqAreaPage != 0 &&
        this.zqAreaPage * 10 >= parseInt(_this.commentCount)
      ) {
        return;
      }
      _this.zqAreaPage += 1;
      _this.$api.universal.dutyArea
        .zqNextGridList(_this.zqAreaPage, _this.zqAreaPageSize, {
          zqCode: _this.dataInfo.zqCode,
          regionLevel: _this.dataInfo.level,
        })
        .then((res) => {
          if (res.code == "1") {
            if (res.data == null) {
              this.resultData = [];
            } else {
              let total = parseInt(res.data.total);
              _this.commentCount = total;
              _this.backstagelists = res.data.list;

              _this.viewLists();
              // 加载状态结束
              _this.loading = false;
              if (_this.zqAreaPage * 10 >= total) {
                _this.zqAreaFinished = true;
                console.log("加载完成");
              }
            }
          } else {
            _this.$toast(res.msg);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    viewLists() {
      this.resultData = this.resultData.concat(this.backstagelists);
    },

    onLoad() {
      // 异步更新数据
      setTimeout(() => {
        this.downList();
      }, 500);
    },
    getLevel(type) {
      //获取责任区等级
      let grade = "";
      if (type == "geo_grid_sheng") {
        grade = "1";
      } else if (type == "geo_grid_shi") {
        grade = "2";
      } else if (type == "geo_grid_xian") {
        grade = "3";
      } else if (type == "geo_grid_xiang") {
        grade = "4";
      } else if (type == "geo_grid_cun") {
        grade = "5";
      } else {
        grade = "";
      }
      return grade;
    },
    getGridLevel(num) {
      let gradeName = "";
      if (num == "1") {
        gradeName = "省级";
      } else if (num == "2") {
        gradeName = "市级";
      } else if (num == "3") {
        gradeName = "县/区级";
      } else if (num == "4") {
        gradeName = "乡/镇级";
      } else if (num == "5") {
        gradeName = "村级";
      } else {
        gradeName = "无";
      }
      return gradeName;
    },
  },
  watch: {
    dataInfo: {
      handler: function () {
        if (this.dataInfo.objid && this.dataInfo.type) {
          this.initzqAreaPage();
        }
      },
      deep: true,
    },
  },
};
</script>
<style lang="less">
.AreaMsgzqAreaPage {
  width: 100%;
  height: 100%;
  padding-bottom: 45px;
  overflow-y: scroll;
  background-color: #f6f6f6;
  .forestInput {
    .van-cell::after {
      position: absolute;
      box-sizing: border-box;
      content: " ";
      pointer-events: none;
      right: 0;
      bottom: 0;
      left: 0.42667rem;
      border-bottom: 0.02667rem solid #ebedf0;
      -webkit-transform: scaleY(0.5);
      transform: scaleY(0.5);
    }
    .van-cell {
      .van-field__label {
        color: #666;
        font-size: 14px;
      }

      .van-cell__value {
        .van-field__control {
          color: #333;
          font-size: 14px;
          text-align: right;
        }
      }

      .van-cell__title {
        width: 120px;
      }
    }

    .van-cell.lbStyle {
      .van-cell__title {
        width: 150px;
      }
    }

    .area {
      padding: 0 16px 10px 16px;
      dl {
        width: 100%;
        padding-top: 10px;
        dt {
          width: 30%;
          font-size: 14px;
          color: #666;
        }

        dd {
          max-width: 65%;
          font-size: 14px;

          color: #333;
          display: block;
          > span {
            text-align: right;
            display: block;
            > span {
              display: inline;
              color: #2d78f4;
            }
          }
        }
      }
    }
  }

  .subordinateTit {
    width: 100%;
    padding: 0 16px;
    height: 45px;
    line-height: 45px;
    font-size: 14px;
    color: #000;
    background-color: #f6f6f6;
    border-top: 1px solid #ebedf0;
    border-bottom: 1px solid #ebedf0;
  }
  .downAreaList {
    width: 100%;
    height: 300px;
    overflow-y: scroll;
    position: relative;
    padding-bottom: 50px;
    .subordinateArea {
      .childArea {
        padding: 0 16px;
        div.childBox {
          width: 100%;
          position: relative;
          border-bottom: 1px solid #ebedf0;
          span.tit {
            display: block;
            font-size: 16px;
            color: #333;
            margin: 3px 0;
          }
          ul {
            li {
              font-size: 14px;
              color: #666;
              span {
                color: #2d78f4;
              }
            }
          }
        }
      }
    }
    .nonezqAreaPage {
      width: 120px;
      height: 150px;

      position: absolute;
      left: 50%;
      margin-left: -60px;
      top: 50%;
      margin-top: -75px;

      img {
        display: block;
        max-width: 100px;
        max-height: 100px;
        margin: 0 auto;
      }

      p {
        margin-top: 10px;
        text-align: center;
        color: #5c5d5d;
        font-size: 16px;
      }
    }
  }
}
</style>